module.exports = __webpack_public_path__ + "static/media/green-line-menu.69145797.svg";